import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'new_customer': {
    title: '最新订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '最新订单客户编号'
    },
    width: 160
  },
  'new_cust_name': {
    title: '最新订单客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'customer': {
    title: '订单客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编号'
    }
  },
  'cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'sal_center': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'zzfld00003e': {
    describe: true, // 描述 _text 添加属性
    title: '基地', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'base' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 180
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 180
  },

  'region': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: cusname
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'total_qty01': {
    title: '1月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty01': {
    title: '1月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty01': {
    title: '1月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty01': {
    title: '1月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty01': {
    title: '1月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty01': {
    title: '1月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty01': {
    title: '1月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty01': {
    title: '1月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty01': {
    title: '1月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty01': {
    title: '1月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty01': {
    title: '1月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate01': {
    title: '1月完成率'
  },
  'total_qty02': {
    title: '2月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty02': {
    title: '2月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty02': {
    title: '2月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty02': {
    title: '2月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty02': {
    title: '2月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty02': {
    title: '2月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty02': {
    title: '2月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty02': {
    title: '2月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty02': {
    title: '2月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty02': {
    title: '2月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty02': {
    title: '2月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate02': {
    title: '2月完成率'
  },
  'total_qty03': {
    title: '3月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty03': {
    title: '3月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty03': {
    title: '3月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty03': {
    title: '3月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty03': {
    title: '3月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty03': {
    title: '3月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty03': {
    title: '3月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty03': {
    title: '3月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty03': {
    title: '3月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty03': {
    title: '3月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty03': {
    title: '3月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate03': {
    title: '3月完成率'
  },
  'total_qty04': {
    title: '4月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty04': {
    title: '4月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty04': {
    title: '4月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty04': {
    title: '4月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty04': {
    title: '4月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty04': {
    title: '4月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty04': {
    title: '4月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty04': {
    title: '4月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty04': {
    title: '4月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty04': {
    title: '4月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty04': {
    title: '4月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate04': {
    title: '4月完成率'
  },
  'total_qty05': {
    title: '5月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty05': {
    title: '5月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty05': {
    title: '5月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty05': {
    title: '5月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty05': {
    title: '5月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty05': {
    title: '5月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty05': {
    title: '5月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty05': {
    title: '5月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty05': {
    title: '5月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty05': {
    title: '5月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty05': {
    title: '5月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate05': {
    title: '5月完成率'
  },
  'total_qty06': {
    title: '6月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty06': {
    title: '6月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty06': {
    title: '6月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty06': {
    title: '6月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty06': {
    title: '6月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty06': {
    title: '6月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty06': {
    title: '6月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty06': {
    title: '6月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty06': {
    title: '6月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty06': {
    title: '6月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty06': {
    title: '6月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate06': {
    title: '6月完成率'
  },
  'total_qty07': {
    title: '7月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty07': {
    title: '7月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty07': {
    title: '7月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty07': {
    title: '7月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty07': {
    title: '7月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty07': {
    title: '7月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty07': {
    title: '7月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty07': {
    title: '7月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty07': {
    title: '7月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty07': {
    title: '7月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty07': {
    title: '7月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate07': {
    title: '7月完成率'
  },
  'total_qty08': {
    title: '8月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty08': {
    title: '8月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty08': {
    title: '8月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty08': {
    title: '8月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty08': {
    title: '8月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty08': {
    title: '8月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty08': {
    title: '8月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty08': {
    title: '8月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty08': {
    title: '8月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty08': {
    title: '8月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty08': {
    title: '8月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate08': {
    title: '8月完成率'
  },
  'total_qty09': {
    title: '9月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty09': {
    title: '9月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty09': {
    title: '9月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty09': {
    title: '9月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty09': {
    title: '9月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty09': {
    title: '9月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty09': {
    title: '9月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty09': {
    title: '9月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty09': {
    title: '9月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty09': {
    title: '9月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty09': {
    title: '9月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate09': {
    title: '9月完成率'
  },
  'total_qty10': {
    title: '10月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty10': {
    title: '10月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty10': {
    title: '10月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty10': {
    title: '10月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty10': {
    title: '10月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty10': {
    title: '10月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty10': {
    title: '10月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty10': {
    title: '10月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty10': {
    title: '10月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty10': {
    title: '10月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty10': {
    title: '10月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate10': {
    title: '10月完成率'
  },
  'total_qty11': {
    title: '11月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty11': {
    title: '11月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty11': {
    title: '11月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty11': {
    title: '11月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty11': {
    title: '11月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty11': {
    title: '11月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty11': {
    title: '11月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty11': {
    title: '11月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty11': {
    title: '11月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty11': {
    title: '11月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty11': {
    title: '11月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate11': {
    title: '11月完成率'
  },
  'total_qty12': {
    title: '12月总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty12': {
    title: '12月初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty12': {
    title: '12月增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty12': {
    title: '12月违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty12': {
    title: '12月中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty12': {
    title: '12月客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty12': {
    title: '12月其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty12': {
    title: '12月预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty12': {
    title: '12月开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty12': {
    title: '12月占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty12': {
    title: '12月剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate12': {
    title: '12月完成率'
  },
  'total_qty_year': {
    title: '全年总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty_year': {
    title: '全年初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'add_qty_year': {
    title: '全年增量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'wgcut_qty_year': {
    title: '全年违规减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zxcut_qty_year': {
    title: '全年中心减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'khcut_qty_year': {
    title: '全年客户减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'qtcut_qty_year': {
    title: '全年其他减量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'ygtz_qty_year': {
    title: '全年预估量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty_year': {
    title: '全年开票量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty_year': {
    title: '全年占用量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty_year': {
    title: '全年剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'comp_rate': {
    title: '全年完成率'
  }

}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealersYearPlanReportForms.js